import { Injectable } from '@angular/core';
import { USER_MGMT_CNST } from '../constants/proj.cnst';
import { Config, Path } from '../enums';
import { InitService } from '../parsers/init.service';
import { UtilsService } from './utils.service';
import { HttpService } from './http.service';
import { EnvService } from './env.service';
import { UM_TABLE_CNST } from '../constants/table.cnst';
import { isNullOrUndefined } from '../shared/common-utils';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private initSrv: InitService,
    private utilsSrv: UtilsService,
    private httpSrv : HttpService,
    private envService : EnvService
  ) { }

  setTableConfig(moduleName: string) {
    let tableConfig: any = {}
    tableConfig['columns'] = UM_TABLE_CNST.TABLE_COLUMNS[moduleName as keyof typeof UM_TABLE_CNST.TABLE_COLUMNS];
    return tableConfig['columns'];
  }

  initializeUserConfig(config: any) {
    return this.initSrv.loadConfig(
      config
    );
  }

  handleOptionClick(e: any, moduleName: string) {
    let modalData: any = []

    if (e.val == USER_MGMT_CNST.OPTIONS.VIEW) {
      if (moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.USER_LIST || moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.USER_CUSTOMER_LIST) {

        const config = {
          path: Path.VIEW_USER_CONFIG_PATH,
          configType: Config.VIEW_USER_CONFIG
        }

        let userId = e['data']['userId'];

        this.getUserInfoByUserId(userId)
          .then((apiResponse: any) => {

            if (!isNullOrUndefined(apiResponse) && Object.keys(apiResponse).length > 0) {
              let { response } = apiResponse;
              let { meta } = response;

              this.initializeUserConfig(config)
                .then(data => {
                  modalData = this.userModalDataValues(e.data, modalData);
                  modalData = this.populateViewUsersModalData(meta, modalData);

                })
                .catch(err => {
                  console.log(err, 'Failed to initialize user config');
                })
            }

          }).catch(err => {
            console.log("Failed to fetch user info");
          })
      } 
    }
    if (e.val == USER_MGMT_CNST.OPTIONS.EDIT) {
      console.log('in edit');

      if (moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.USER_LIST || moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.USER_CUSTOMER_LIST) {
        const config = {
          path: Path.EDIT_USER_CONFIG_PATH,
          configType: Config.EDIT_USER_CONFIG
        }

        this.initializeUserConfig(config)
          .then(data => {
            modalData = this.userModalDataValues(e.data, modalData);
            modalData.editAction = true;
          })
          .catch(err => {
            console.log(err, 'waringin here');
          })
      }
      if (moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.PROFILE_LIST || moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.PROFILE_CUSTOMER_LIST) {
        modalData.editAction = true;
      }
    }
  }

  userModalDataValues(rowData: any, modalData: any) {
    return rowData;
  }

  roleModalDataValues(rowData: any, modalData: any) {
    ;
    modalData.rolename = rowData[0]['values'][0]
    modalData.roledesc = rowData[1]['values'][0]
    modalData.status = rowData[2]['values'][0]
  }

  profileModalDataValues(rowData: any, modalData: any) {
    ;
    modalData.profilename = rowData[0]['values'][0]
    modalData.profiledesc = rowData[1]['values'][0]
    modalData.status = rowData[2]['values'][0]
  }

  adminModalDataValues(rowData: any, modalData: any) {
    ;
    modalData.administratorName = rowData[0]['values'][0]
    modalData.administratorDesc = rowData[1]['values'][0]
    modalData.status = rowData[2]['values'][0]
  }

  loadConfig(config: any){
    let configs = this.initSrv.getConfig(config.configType)
    if(!isNullOrUndefined(configs)){
      return configs;
    }
    return this.initSrv.loadConfig(config);
  }

  getProfilesList(options : any) : Promise<any> {
    let promise = new Promise((resolve) => {
      this.httpSrv
        .makeGetApiCall("LIST_OF_PROFILES", this.envService.baseUrl, options)
        .subscribe({next:(response: any[]) => {
          resolve(response);
        }, 
        error:err => {
          console.log("Error in fetching roles list ", err);
          this.utilsSrv.showToastMessage("Error in fetching roles list ", "error");
          resolve({});
        }
        })
    })

    return promise;
  }

  getUserInfoByUserId(userId : string) : Promise<any> {

    let promise = new Promise((resolve) => {

      if (!isNullOrUndefined(userId)) {

        let payload = {
            userId
        }

        this.httpSrv
          .makePostApiCall('FETCH_USER_INFO_BY_ID', payload, this.envService.baseUrl)
          .subscribe({next:(response: any) => {
            resolve(response);
          },
          error:error => {
            console.log("Error in fetching user info by user id ", error);
            this.utilsSrv.showToastMessage("Error in fetching user info", "error");
            resolve({});
          }
          })
      }
    })
    return promise;
  }

  populateViewUsersModalData(response : any, modalData : any) : any {
    if (this.utilsSrv.isObjectNotNullAndEmpty(response)) {
      modalData['firstName'] = response.firstName;
      modalData['lastName'] = isNullOrUndefined(response.lastName) ? '-' : response.lastName;
      modalData['emailId'] = response.email;
      modalData['title'] = isNullOrUndefined(response.title) ? '-' : response.title;
      modalData['lastLoginTs'] = isNullOrUndefined(response.lastLoginTs) ? null : response.lastLoginTs;
      modalData['status'] = response.status ? "Active" : "Inactive";
      modalData['username'] = response.username;
      modalData['mobileNumber'] = response.mobileNo;
    }

    return modalData;
  }

  navigateToCustomApp(appDetails: any) {
    const realmDetails = JSON.parse(localStorage.getItem(USER_MGMT_CNST.REALM_DETAILS_KEY) ?? '{}');
    const customerRealmDetails: any = JSON.parse(realmDetails?.customerRealmDetailsJson ?? '{}');
    let queryParams = {
      realm: realmDetails?.realmName ?? this.envService.keyCloakOptions.realm,
      clientId: customerRealmDetails?.client_id ?? this.envService.keyCloakOptions.clientId,
    };
    const queryString = new URLSearchParams(queryParams).toString();
    window.location.href = `${appDetails?.applicationUrl}?${queryString}`;
  }
}
